import { pgTable, uuid, text, boolean, integer, timestamp } from "drizzle-orm/pg-core";

export const inventoryLocations = pgTable("inventory_locations", {
  id: uuid("id").primaryKey().defaultRandom(),
  code: text("code").notNull().unique(),
  name: text("name").notNull(),
  type: text("type").notNull().$type<"shop" | "warehouse">(),
  address: text("address"),
  postalCode: text("postal_code"),
  city: text("city"),
  country: text("country").notNull().default("LV"),
  // Used as the sender block on courier waybills. company_code is org-
  // wide for the 3 Vīnoga stores but is per-row so a future warehouse
  // under a different legal entity wouldn't need a schema change.
  companyCode: text("company_code"),
  contactPerson: text("contact_person"),
  contactPhone: text("contact_phone"),
  contactEmail: text("contact_email"),
  // When a courier order has no explicit fulfilment store assigned,
  // it defaults to this one. Partial unique index in the migration
  // guarantees only one row is true at a time.
  isDefaultFulfilment: boolean("is_default_fulfilment").notNull().default(false),
  isPickupPoint: boolean("is_pickup_point").notNull().default(false),
  active: boolean("active").notNull().default(true),
  position: integer("position").notNull().default(0),
  createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
  updatedAt: timestamp("updated_at", { withTimezone: true }).notNull().defaultNow(),
});

export type InventoryLocation = typeof inventoryLocations.$inferSelect;
export type NewInventoryLocation = typeof inventoryLocations.$inferInsert;

export const INVENTORY_LOCATION_TYPES = ["shop", "warehouse"] as const;
export type InventoryLocationType = (typeof INVENTORY_LOCATION_TYPES)[number];
